export const UPDATE_QUESTION_SUCCESS = "La question a été modifiée.";
export const ADD_QUESTION_SUCCESS = "La question a été ajoutée.";
export const DELETE_QUESTION_SUCCESS = "La question a été supprimée.";



// WEBPACK FOOTER //
// ./src/successes/feedbacks.js